export default "__VITE_ASSET__1GfXEx2U__"